import { default as OverrideService } from './OverrideService';

export const __ov = (text: string) => {
  return OverrideService.overrideText(text);
};

export { default as OverrideService } from './OverrideService';
